import { useEffect, useRef, useState } from 'react';
import { partnerBrands } from '@/mocks/homeData';

export default function PartnerBrands() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-16 md:py-24 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-16">
        {/* Header - 简化 */}
        <div className="text-center mb-12 md:mb-14">
          <h2
            className={`text-2xl md:text-3xl lg:text-4xl font-bold text-[#1E5FAD] mb-3 transition-all duration-600 delay-100 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            他们选择与融慧数科同行
          </h2>
          <p
            className={`text-sm text-[#666666] transition-all duration-600 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            覆盖快消饮料、食品、乳品、日化、啤酒、调味品等多个细分赛道，累计服务多家头部品牌
          </p>
        </div>

        {/* Brand Logo Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6">
          {partnerBrands.map((brand, index) => (
            <div
              key={index}
              className={`group flex items-center justify-center h-24 md:h-28 bg-[#F8F9FB] rounded-xl border border-gray-100 hover:border-[#00AEEF]/25 hover:bg-white transition-all duration-300 cursor-pointer ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
              }`}
              style={{
                transitionDelay: `${200 + index * 50}ms`,
                boxShadow: '0 1px 6px rgba(0,0,0,0.03)',
              }}
              title={brand.name}
            >
            <img
                src={brand.logo}
                alt={brand.name}
                className="max-w-[85%] max-h-[75%] object-contain transition-all duration-300 group-hover:scale-105"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}